const useFormData = () => {
  const renderFormData = (formObject, authorizedObjects = []) => {
    const formData = new FormData()
    for (const prop in formObject) {
      if (typeof formObject[prop] !== 'object' || authorizedObjects.indexOf(prop) >= 0) {
        let value = formObject[prop]
        if ("" !== value) {
          if (authorizedObjects.indexOf(prop) >= 0) {
            value = JSON.stringify(value)
          }
          formData.append(prop, value)
        }
      }
    }

    return formData
  }

  return renderFormData
}

export default useFormData